
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M12 23C13.1 23 13.99 22.11 13.99 21.01H10.01C10.01 22.11 10.9 23 12 23ZM19 17V11C19 7.65 16.64 4.85 13.5 4.17V3C13.5 2.17 12.83 1.5 12 1.5C11.17 1.5 10.5 2.17 10.5 3V4.17C7.35999 4.85 4.99999 7.65 4.99999 11V17L3.70999 18.29C3.07999 18.92 3.51999 20 4.40999 20H19.58C20.47 20 20.92 18.92 20.29 18.29L19 17ZM15 13.01H13V15.01C13 15.56 12.55 16.01 12 16.01C11.45 16.01 11 15.56 11 15.01V13.01H8.99999C8.44999 13.01 7.99999 12.56 7.99999 12.01V12C7.99999 11.45 8.44999 11 8.99999 11H11V9C11 8.45 11.45 8 12 8C12.55 8 13 8.45 13 9V11H15C15.55 11 16 11.45 16 12V12.01C16 12.56 15.55 13.01 15 13.01Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-add-alert`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconAddAlert

    ```js
    <b-new-b-icon-add-alert />
    ```
</docs>


